export const options = [
  { value: 'isAnyOf', label: 'Is any of', showSelect: true },
  { value: 'isNoneOf', label: 'Is none of', showSelect: true },
];

export const optionTitles = {
  isAnyOf: 'is any of',
  isNoneOf: 'is none of',
};
